import React, { useEffect, useState } from "react";

import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import clsx from "clsx";
import mainStyles from "styles";

import { EnumSelectProps } from "types/org-display";

const EnumRadio: React.FC<EnumSelectProps> = ({
  enum: enumProp,
  label,
  defaultValue,
  onValueChange,
  displayMapping,
}) => {
  const classes = mainStyles();
  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    setSelectedValue(defaultValue || "");
  }, [defaultValue]);

  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    const value = event.target.value as string;
    setSelectedValue(value);
    if (onValueChange) {
      onValueChange(value);
    }
  };

  return (
    <Box sx={{ width: "100%", paddingTop: "0.5rem" }}>
      <FormControl
        variant="outlined"
        size="small"
        className={clsx(classes.spaceTopSmall, classes.spaceRightMedium)}
        fullWidth
      >
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup value={selectedValue} onChange={handleChange}>
          {Object.entries(enumProp)
            .filter(([, value]) => typeof value !== "string" && value !== 0)
            .map(([key, value]) => (
              <FormControlLabel
                key={key}
                value={value}
                control={<Radio />}
                label={displayMapping ? displayMapping[value] || key : key}
                sx={{ m: 0 }}
              />
            ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default EnumRadio;
